<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KloLpX/html/docimages/cover_ader.jpg?1684515193640" alt="This image is the cover for the book Rock Diary: Buddy Holly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rock Diary: Buddy Holly
      </h1>
      <p class="bookDescription body article font2">
        <p>Rock Diary: Buddy Holly is a unique, chronological, day-by-day, month-by-month and year-by-year history of the life and career of one of the most popular and influential musicians of all-time. This definitive factual story is the ultimate biographical timeline of one of the architects of rock ‘n’ roll - from his earliest days as a teenager in Lubbock, Texas through his phenomenal rise as one of America’s leading rock pioneers to his tragic early death on the ‘day the music died’. Also a continuing timeline on the events and triumphs which make up Holly’s astonishing legacy, right up to the present day. Every Holly fact, each recording session and tour, television and radio appearances, all US and UK singles and albums chart and gold/platinum sales achievements, every award ever won, his personal highs and lows - all are included in this detailed, comprehensive rock diary. Simply the best value for the complete history - and backstory - of this iconic star. This is the second volume in the unrivaled Rock Diary series which also includes individual, comprehensive biographies on all the rock greats including the Beatles, the Rolling Stones, Elvis Presley, Pink Floyd, U2, Coldplay, Led Zeppelin, Lady Gaga - even Spinal Tap.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dafydd Rees, Luke Crampton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Original Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a429f160